import React from 'react';

function About() {
  return (
    <div className="fade-in about-page">
      <div className="hero">
        <h1>About Us</h1>
        <p>Born of vision, driven by compassion, committed to service</p>
      </div>

      <div className="content-section container">
        <h2>History of the Foundation</h2>
        <p>
          Born of the vision of Mr. NC Maharaj, the name "Shantik" is rooted in the word "shanti," which translated from Hindi, symbolizes peace. Peace is the ultimate goal in life and all of us strive for it in different forms and ways.
        </p>
        <p>
          Incidentally, it is a moniker derived from the names of the parents of the chairman - His mum was Shanti and dad's family name Tikka, hence SHANTIK. This is a testament to the value system, sense of family and community that inspired his career and guided his journey to philanthropy.
        </p>
        <p>
          In the words of Swami Sivananda of the Divine Life Society, <strong>"Service to mankind is worship of God."</strong> The Foundation embraces the rich philosophy of the ancient religion and is a good example of Ubuntu in action.
        </p>
      </div>

      <div className="content-section container">
        <h2>Community Spirit & Founder's Profile</h2>
        <p>
          Mr. N.C. Maharaj's commitment to community upliftment began in his early youth. Together with friends, he organized a football and debating team in Umhlatuzana Township, a neighbouring suburb to Chatsworth. The football team, consisting mainly of youth, was affiliated with the Sea View and District Football Association. Mr. Maharaj was an active player and later went on to represent the Association in the greater Durban area.
        </p>
        <p>
          In the early 1960s, his family relocated to Bayview, Chatsworth. He continued his involvement in football while commencing employment as a clerk and simultaneously pursuing tertiary studies on a part-time basis.
        </p>
        <p>
          During the mid-1960s, Mr. Maharaj, together with other residents, established the Chatsworth Cricket Union, where he served as its first Honorary Secretary. At the same time, he formed a cricket club comprised mainly of students, which was affiliated with the Union.
        </p>

        <h3>Religious and Cultural Contributions</h3>
        <p>
          On the religious front, Mr. Maharaj founded the Chatsworth Hindu Mundal, which organized Satsangs and Hindu festivals on open grounds. In the late 1960s, the Mandal acquired a religious site on Silverglen Drive, opposite the Odeon Cinema in Unit 3, Chatsworth. Today, a beautiful Hindu temple stands on this site as a lasting legacy of those early efforts.
        </p>
        <p>
          He also worked closely with the Hindi Shiksha Sangh and the Arya Samaj to promote Hindi education, hosting classes at government schools in Bayview. While pursuing his academic career, he served as Assistant Secretary of the Sanathan Dharma Sabha (SA).
        </p>

        <h3>Professional Career</h3>
        <p>
          In the early 1970s, Mr. Maharaj temporarily stepped away from his community activities to undertake a traineeship in the auditing and accounting profession in Johannesburg. He went on to practice as a Chartered Accountant in Durban for over 45 years, retiring in March 2025. He was among the first persons of colour in South Africa to qualify as a Chartered Accountant and to open a professional practice. Many trainee accountants completed their articles under his guidance and today hold prominent positions within the business community.
        </p>
        <p>
          His practice earned a strong reputation for integrity, professionalism, and service. Mr. Maharaj was widely respected as an advisor, mentor, consultant, and trusted friend to his clients and colleagues.
        </p>

        <h3>Business & Other Interests</h3>
        <p>
          Mr. Maharaj has a strong interest in the hospitality industry and property development and remains actively involved in these ventures for the benefit of the Shantik Foundation. He played an important role in syndicating Hindu business persons with the object of forming a united investment enterprise in acquiring properties and other assets, which is still in existence today.
        </p>
        <p>
          In his younger years, he played football and cricket competitively. Today, he continues to follow these sports enthusiastically and enjoys swimming, golf, and walking. Mr. Maharaj also enjoys a good game of Thunnee, a popular Indian card game.
        </p>

        <h3>Personal Life</h3>
        <p>
          In 1973, Mr. Maharaj married Usha, and the marriage lasted until 2024 when she passed away. She was a strong supporter of N.C. in his endeavors and shared in his vision of assisting the underprivileged at all levels.
        </p>

        <h3>Shantik Foundation</h3>
        <p>
          Driven by a lifelong commitment to service, Mr. N.C. Maharaj founded the Shantik Foundation, a non-profit organization based in Durban, South Africa, dedicated to assisting poor and disadvantaged communities. The Foundation reflects his enduring belief in compassion, service, and sustainable community development.
        </p>
      </div>

      <div className="content-section container">
        <h2>Board of Directors</h2>
        <div className="board-grid">
          <div className="board-member">
            <h4>N.C. Maharaj</h4>
            <p>B.Comm {'{CA}{SA}'} Retired Chartered Accountant</p>
          </div>
          <div className="board-member">
            <h4>Dewanundh Kooblall (Roshan)</h4>
            <p>Educationist / Social and Cultural Activist</p>
          </div>
          <div className="board-member">
            <h4>Priyaneshree Lallupersad</h4>
            <p>Snr Manageress in Public Services<br />Dept of Health</p>
          </div>
          <div className="board-member">
            <h4>Ajen Rooplal</h4>
            <p>Businessman</p>
          </div>
          <div className="board-member">
            <h4>Dinesh Naidoo</h4>
            <p>Businessman</p>
          </div>
          <div className="board-member">
            <h4>Omesh Misra</h4>
            <p>Accountant and Tax Practitioner</p>
          </div>
          <div className="board-member">
            <h4>Jivika Jaikarun</h4>
            <p>Youth Coordinator</p>
          </div>
        </div>
      </div>

      <div className="content-section container">
        <h2>Registration Details</h2>
        <p>The Foundation is a Non Profit Company registered with the following Government Departments:</p>
        <ul>
          <li><strong>Company offices – Pretoria (CIPC)</strong> Reg No.: 2017/446405/08</li>
          <li><strong>Non-Profit Organisation (NPO)</strong> Reg No.: 201-859</li>
          <li><strong>Public Benefit Organisation (PBO)</strong> Reg No: 930061074</li>
          <li><strong>Income Tax No.:</strong> 9205143234</li>
        </ul>
      </div>
    </div>
  );
}

export default About;
